import { Typography } from "@mui/material";
import { maxHeight, width } from "@mui/system";

export const fontWeightSchemes = {
    "fontWeight400": "400",
    "fontWeight500": "500",
    "fontWeight600": "600",
    "fontWeight700": "700",
    "fontWeight800": "800",
    "fontWeight900": "900",
}
export const TaskSearchWidth = "28%"
export const TaskFilterWidth = "28%"
export const TaskDetailWidth = `calc(100% - ${TaskSearchWidth} + ${TaskFilterWidth})`

export const fontSizeSchemes = {
    "font28": "1.75rem",    // 28px
    "font27": "1.6875rem",  // 27px
    "font26": "1.625rem",   // 26px
    "font25": "1.5625rem",  // 25px
    "font24": "1.5rem",     // 24px
    "font23": "1.4375rem",  // 23px
    "font22": "1.375rem",   // 22px
    "font21": "1.3125rem",  // 21px
    "font20": "1.25rem",    // 20px
    "font19": "1.1875rem",  // 19px
    "font18": "1.125rem",   // 18px
    "font17": "1.0625rem",  // 17px
    "font16": "1rem",       // 16px
    "font15": "0.9375rem",  // 15px
    "font14": "0.875rem",   // 14px
    "font13": "0.8125rem",  // 13px
    "font12": "0.75rem",    // 12px
    "font11": "0.6875rem",  // 11px
    "font10": "0.625rem",   // 10px
    "font9": "0.5625rem",   // 9px
    "font8": "0.5rem",      // 8px
    "font7": "0.4375rem",   // 7px
    "font6": "0.375rem",    // 6px
    "font5": "0.3125rem",   // 5px
    "font4": "0.25rem",     // 4px
    "font3": "0.1875rem",   // 3px
    "font2": "0.125rem",    // 2px
    "font1": "0.0625rem",   // 1px
}
export const commonButtonHeight = "30px";
export const colorSchemes = {
    "switchTxtLink":'#2C86FF',
    "crossIconBorder":"#193243",
    'personIconBg':'#F3F3F3',
    'black':'#000000',
    'transparent':'transparent',
    'boxBgColor':'#F3F3F3',
    'white':'#FFFFFF',
    'lightGray':'#D9D9D9',
    'themeRedColor':'#DB0011',
    'chipIconBlueColor' : '#193243',
    'red':'red',
    'searchBgColor':'#E1E1E1',
    "reopenedColor":"#2C86FF"
};

export const dueToCustomRange = "due_in_custom_range"

export const taskButtonStyle = {
    borderRadius: "2px",
    textAlign: "center",
    // width:'64px',
    // height:"25px",
    // maxHeight:"25px",
    // maxWidth: "90px",
    justifyContent: "center",
    alignItems: "center",
    whiteSpace: "nowrap",
    cursor: "pointer",
    padding: "0.2rem 0.5rem 0.2rem 0.5rem",   
    border: "1px solid #000000",    
    backgroundColor: colorSchemes.white,                       
}

export const taskButtonTxtStyle = {
        marginLeft: "2px !important;",
        whiteSpace: "nowrap",
        fontWeight: "400",
        color: colorSchemes.black,
        fontSize: fontSizeSchemes.font14,    
}

export const crossIconDiv = {
    backgroundColor: "transparent",
    position: "relative",
    height: "30px",
    width: "30px",
    cursor: "pointer",
    padding: "4px",
    borderRadius: "2px",
    border: `1px solid ${colorSchemes.crossIconBorder}`,
};

export const crossIcon = {
    color: colorSchemes.crossIconBorder,
    height: "100%",
    width: "100%",
}


export const personIconStyle = {
     width: 15, height: 15 
}

export const statusLabelStyleBox = {      
    textAlign: "center",
    justifyContent: "center",
    cursor: "pointer",
    borderRadius: "20px",
    minWidth: "80px",
    maxWidth: "160px",
    width: "fit-content",
    alignItems:"center",
    padding: "2px 8px ",
}
export const FloatBtnStyle = {
    position: "absolute",
    bottom: "5rem",
    right: 24,
    zIndex: 10,
    cursor: "pointer",
    background: colorSchemes.white,
    borderRadius: "50%",
    width: 45,
    height: 45,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
  }

  export const FloatImgStyle = {
    width: 46, height: 46
  }

  export const DividerStyle = {
    height:"15px",
    width:2,
    backgroundColor:"black",
    color:"black",
    alignItems:'center',
    alignSelf:'center',
  }

  

